import { emailValidator, required } from "Modules/Customer/Subscription/AddSubscription";
import React, { useState } from "react";
import { Alert, Button, Col,Row, Form, Modal, Spinner } from "react-bootstrap";
import * as StaffApi from '../../Services/StaffService';

const onboardingValidators = [
    {
        key: "firstName",
        validators: [required],
    },
    {
        key: "lastName",
        validators: [required],
    },
    {
        key: "email",
        validators: [required, emailValidator],
    },

]

const OnboardStaff = ({ show, handleClose }) => {

    const [formData, setFormData] = useState({ values: {  }, errors: {} });
    const [submitting, setSubmitting] = useState(false);
    const [apiError, setApiError] = useState(undefined);    

    const validateForm = (data)=>{
        const errors = {};
        onboardingValidators.forEach(({ key, validators }) => {
            const value = data[key];
            let error;
            validators.forEach(validator => {
                if (!error) {
                    error = validator(value, data);
                }
            });
            if (error) {
                errors[key] = error;
            }
        });
        return errors;
    }

    const handleChange = (field, value) => {
        setFormData((prevFormData) => {
            const { values: prevValues, errors: prevErrors } = prevFormData;
            const validators = onboardingValidators.find(({key})=>(key === field))?.validators || [];
            let error;
            validators.forEach(validator => {
                if (!error) {
                    error = validator(value);
                }
            });
            return {
                ...prevFormData,
                values: { ...prevValues, [field]: value },
                errors: { ...prevErrors, [field]: error}
            }
        });
    }

    const onSubmit = async () => {
        const { values: data } = formData;

        const errors = validateForm(data);

        if (Object.keys(errors).length > 0) {
            setFormData((prevFormData) => {
                const { errors: prevErrors } = prevFormData;
                return {
                    ...prevFormData,
                    errors: { ...prevErrors, ...errors }
                }
            })
            return;
        }
        setSubmitting(true);
        setApiError(undefined);
        

        const sanitizedData = {
            ...data           
        };

        try {
            await StaffApi.onboardStaff(sanitizedData);
            setSubmitting(false);
            handleClose();
        } catch (e) {
            setApiError(e?.message || "System error");
            setSubmitting(false);
            console.log(e)
        }

    }

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                Onboard Staff
            </Modal.Header>
            <Modal.Body>
                <Form >
                    <Form.Group as={Row} className="mb-3" controlId="frmfirstName">
                        <Form.Label column sm={3}>
                            First Name*
                        </Form.Label>
                        <Col sm={9}>
                            <Form.Control
                                type="text" placeholder=""
                                value={formData?.values?.firstName || ''}
                                onChange={(e) => handleChange('firstName', e.target.value)}
                                isInvalid={formData?.errors?.firstName}
                            />
                            {formData?.errors?.firstName && (<span className="error-text">
                                {formData?.errors?.firstName}
                            </span>)}
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3" controlId="frmlastName">
                        <Form.Label column sm={3}>
                            Last Name*
                        </Form.Label>
                        <Col sm={9}>
                            <Form.Control
                                type="text" placeholder=""
                                value={formData?.values?.lastName || ''}
                                onChange={(e) => handleChange('lastName', e.target.value)}
                                isInvalid={formData?.errors?.lastName}
                            />
                            {formData?.errors?.lastName && (<span className="error-text">
                                {formData?.errors?.lastName}
                            </span>)}
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3" controlId="frmemail">
                        <Form.Label column sm={3}>
                            Email*
                        </Form.Label>
                        <Col sm={9}>
                            <Form.Control
                                type="text" placeholder=""
                                value={formData?.values?.email || ''}
                                onChange={(e) => handleChange('email', e.target.value)}
                                isInvalid={formData?.errors?.email}
                            />
                            {formData?.errors?.email && (<span className="error-text">
                                {formData?.errors?.email}
                            </span>)}
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3" controlId="frmaexDropDownName">
                        <Form.Label column sm={3}>
                            AEX Dropdown Name
                        </Form.Label>
                        <Col sm={9}>
                            <Form.Control
                                type="text" placeholder=""
                                value={formData?.values?.aexDropDownName || ''}
                                onChange={(e) => handleChange('aexDropDownName', e.target.value)}
                                isInvalid={formData?.errors?.aexDropDownName}
                            />
                            {formData?.errors?.aexDropDownName && (<span className="error-text">
                                {formData?.errors?.aexDropDownName}
                            </span>)}
                        </Col>
                    </Form.Group>
                </Form>
                {apiError && (
                    <Alert variant="danger">{apiError}</Alert>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
               <Button variant="primary" onClick={onSubmit} disabled={submitting}>
                    {submitting && <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />}
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default OnboardStaff;